import script from "./SettingsTimecardContent.vue?vue&type=script&setup=true&lang=ts"
export * from "./SettingsTimecardContent.vue?vue&type=script&setup=true&lang=ts"

import "./SettingsTimecardContent.vue?vue&type=style&index=0&id=bf98defc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bf98defc"]])

export default __exports__